import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../../../../components/Icon'
import { ReactComponent as CircleFilled } from '../../../../../../../assets/icons/sroi/circleFilled.svg'
import { ReactComponent as Circle } from '../../../../../../../assets/icons/sroi/circle.svg'

import useStyles from './styles'

const MAX_CIRCLES = 15
const CIRCLES_PER_ROW = 5

const Circles = ({ filledCount }) => {
  const classes = useStyles()

  const rows = useMemo(() => {
    // Cap at MAX_CIRCLES and round to nearest integer
    const filled = Math.min(Math.round(filledCount), MAX_CIRCLES)
    const empty = MAX_CIRCLES - filled

    // Create array of circle states (true = filled, false = empty)
    const circles = [...Array(filled).fill(true), ...Array(empty).fill(false)]

    // Split circles into rows of 5
    const result = []
    for (let i = 0; i < circles.length; i += CIRCLES_PER_ROW) {
      result.push(circles.slice(i, i + CIRCLES_PER_ROW))
    }
    return result
  }, [filledCount])

  return (
    <>
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className={classes.circlesContainer}>
          {row.map((isFilled, circleIndex) => (
            <Icon key={circleIndex}>{isFilled ? <CircleFilled /> : <Circle />}</Icon>
          ))}
        </div>
      ))}
    </>
  )
}

Circles.propTypes = {
  filledCount: PropTypes.number.isRequired
}

export default Circles
